import React from 'react'
import { Tag } from 'antd'

export const StatementsTab: React.FC = () => {
  return <Tag>In development</Tag>
}
